export const FETCH_CHARTS_DATA_SUCCESS = 'FETCH_CHARTS_DATA_SUCCESS';

export const FETCH_CHARTS_DATA_FAILURE = 'FETCH_CHARTS_DATA_FAILURE';